import React from "react";
import styles from "./page2.scss";
import img_2014 from "./2014.png";
import img_2015 from "./2015.png";
import img_2016 from "./2016.png";
import img_2017 from "./2017.png";
import img_2018 from "./2018.png";
import img_2019_1 from "./2019-1.png";
import img_2019_2 from "./2019-2.png";
import img_2020_1 from "./2020-1.png";
import img_2020_2 from "./2020-2.png";
import img_2020_3 from "./2020-3.png";
import img_2021_1 from "./2021_1.png";
import img_2021_2 from "./2021_2.png";
import img_2023 from "./2023.png";
import { getRem } from "../../func";

function Page2(props) {
  return (
    <div className={styles["page2"]} ref={props.myRef}>
      <div className={styles["page2-main"]}>
        <div className={`${styles["page2-title"]} animate2-wrapper`}>
          <div
            r="58"
            g="98"
            b="109"
            className={`maskBlock animate2`}
            style={{ background: "rgb(58, 98, 109)" }}
          />
          DEVELOPMENT
          <br />
          PATHWAYS
        </div>

        <div className={styles["page2-subTitle"]}>
          <div className={styles["page2-subTitle-circle"]}>2</div>

          <div className={styles["page2-subTitle-text"]}>发展历程</div>
        </div>

        <div className={styles["page2-timeline"]}>
          <div className={styles["page2-timeline-year"]}>2014</div>
          <div className={styles["page2-timeline-line"]}>
            <div
              className={styles["page2-timeline-desc"]}
              style={{ bottom: getRem(42) }}
            >
              <div className={styles["page2-timeline-desc-title"]}>开篇</div>

              <div className={styles["page2-timeline-desc-text"]}>
                2014年7月，深圳市星潮热点传播股份有限公司（简称WOW-TREND热点趋势）于深圳成立。
                <div
                  r="50"
                  g="83"
                  b="93"
                  className={`${styles.maskBlock} animate1`}
                  style={{ background: "rgb(50, 83, 93)" }}
                />
              </div>
            </div>

            <div
              className={styles["page2-timeline-pic"]}
              style={{
                width: getRem(440),
                height: getRem(296),
                top: getRem(40),
                right: getRem(-15),
              }}
            >
              <img src={img_2014} />
            </div>
          </div>

          <div className={styles["page2-timeline-year"]}>2015</div>
          <div className={styles["page2-timeline-line"]}>
            <div
              className={styles["page2-timeline-desc"]}
              style={{ top: getRem(39) }}
            >
              <div className={styles["page2-timeline-desc-title"]}>启程</div>

              <div className={styles["page2-timeline-desc-text"]}>
                2015年3月，WOW-TREND趋势网上线。
                <div
                  r="50"
                  g="83"
                  b="93"
                  className={`${styles.maskBlock} animate1`}
                  style={{ background: "rgb(50, 83, 93)" }}
                />
              </div>
            </div>

            <div
              className={styles["page2-timeline-pic"]}
              style={{
                width: getRem(328),
                height: getRem(190),
                bottom: getRem(133),
                left: getRem(4),
              }}
            >
              <img style={{ width: "auto", height: "auto" }} src={img_2015} />
            </div>
          </div>

          <div className={styles["page2-timeline-year"]}>2016</div>
          <div className={styles["page2-timeline-line"]}>
            <div
              className={styles["page2-timeline-desc"]}
              style={{ bottom: getRem(42) }}
            >
              <div className={styles["page2-timeline-desc-title"]}>探索</div>

              <div className={styles["page2-timeline-desc-text"]}>
                2016年1月，拥有全球资源的高端教育平台——FASHION-IN时尚经纬诞生。
                <div
                  r="50"
                  g="83"
                  b="93"
                  className={`${styles.maskBlock} animate1`}
                  style={{ background: "rgb(50, 83, 93)" }}
                />
              </div>
            </div>

            <div
              className={styles["page2-timeline-pic"]}
              style={{
                width: getRem(440),
                height: getRem(296),
                top: getRem(40),
                right: getRem(-15),
              }}
            >
              <img src={img_2016} />
            </div>
          </div>

          <div className={styles["page2-timeline-year"]}>2017</div>
          <div className={styles["page2-timeline-line"]}>
            <div
              className={styles["page2-timeline-desc"]}
              style={{ top: getRem(39) }}
            >
              <div className={styles["page2-timeline-desc-title"]}>荣誉</div>

              <div className={styles["page2-timeline-desc-text"]}>
                2017年，获得国家级国家高新企业认证，这在中国服饰时尚行业里是特例，同时取得多项产品软件、计算机软件著作权及其他知识产权认证。
                <div
                  r="50"
                  g="83"
                  b="93"
                  className={`${styles.maskBlock} animate1`}
                  style={{ background: "rgb(50, 83, 93)" }}
                />
              </div>
            </div>

            <div
              className={styles["page2-timeline-pic"]}
              style={{
                width: getRem(328),
                height: getRem(190),
                bottom: getRem(133),
                left: getRem(4),
              }}
            >
              <img style={{ width: "auto", height: "auto" }} src={img_2017} />
            </div>
          </div>

          <div className={styles["page2-timeline-year"]}>2018</div>
          <div className={styles["page2-timeline-line"]}>
            <div
              className={styles["page2-timeline-desc"]}
              style={{ bottom: getRem(42) }}
            >
              <div className={styles["page2-timeline-desc-title"]}>突破</div>

              <div className={styles["page2-timeline-desc-text"]}>
                2018年12月，WOW-TREND热点趋势内容全面升级，客户访问量达近一亿人次。并开创WOW-MAX设计定制项目，从面料、色彩、成衣定制等版块有效的提升了产品的落地性、独特性。
                <div
                  r="50"
                  g="83"
                  b="93"
                  className={`${styles.maskBlock} animate1`}
                  style={{ background: "rgb(50, 83, 93)" }}
                />
              </div>
            </div>

            <div
              className={styles["page2-timeline-pic"]}
              style={{
                width: getRem(440),
                height: getRem(296),
                top: getRem(40),
                right: getRem(-15),
              }}
            >
              <img src={img_2018} />
            </div>
          </div>

          <div className={styles["page2-timeline-year"]}>2019</div>
          <div className={styles["page2-timeline-line"]}>
            <div
              className={styles["page2-timeline-desc"]}
              style={{ top: getRem(39) }}
            >
              <div className={styles["page2-timeline-desc-title"]}>跨越</div>

              <div className={styles["page2-timeline-desc-text"]}>
                2019年10月，WOW-TREND热点趋势CEO/首席创意官李冰荣获北京服装学院建校60周年颁发的“2019北服时尚人物”
                <br />
                <br />
                2019年12月，受法国Première Vision
                Paris趋势研究媒体邀约参与面料展时尚趋势版块的研究分享，成为中国市场数据采集、时尚趋势版块、媒体版块深度合作伙伴
                <div
                  r="50"
                  g="83"
                  b="93"
                  className={`${styles.maskBlock} animate1`}
                  style={{ background: "rgb(50, 83, 93)" }}
                />
              </div>
              <div
                style={{
                  width: getRem(156),
                  height: getRem(36),
                  marginTop: getRem(12),
                }}
              >
                <img style={{ display: "block" }} src={img_2019_1} />
              </div>
            </div>

            <div
              className={styles["page2-timeline-pic"]}
              style={{
                width: getRem(440),
                height: getRem(296),
                bottom: getRem(40),
                left: getRem(4),
              }}
            >
            <img src={img_2019_2} />
            </div>
          </div>

          <div className={styles["page2-timeline-year"]}>2020</div>
          <div className={styles["page2-timeline-line"]}>
            <div
              className={styles["page2-timeline-desc"]}
              style={{ bottom: getRem(22) }}
            >
              <div className={styles["page2-timeline-desc-text"]}>
                <span className="animate1-wrapper">
                  2020年1月，与意大利马兰戈尼学院深圳分院达成教育战略合作，为怀揣设计梦的人士提供业界顶尖的时尚教育资源；
                  <br />
                  <div
                    r="50"
                    g="83"
                    b="93"
                    className={`${styles.maskBlock} animate1`}
                    style={{ background: "rgb(50, 83, 93)" }}
                  />
                </span>

                <div
                  style={{
                    width: getRem(176),
                    height: getRem(37),
                    marginTop: getRem(12),
                  }}
                >
                  <img src={img_2020_1} />
                </div>
                <br />
              </div>
            </div>

            <div
              className={styles["page2-timeline-desc"]}
              style={{ bottom: getRem(-132) }}
            >
              <div className={styles["page2-timeline-desc-text"]}>
                <span className="animate1-wrapper">
                  2020年5月,英国创意设计工作室FWS
                  Design是国际知名的图案设计工作室，作为法国PV展图案板块的固定合作伙伴，客户包括Missoni、DKNY、玛丝菲尔等品牌。2020年，WOW-TREND携手FWS
                  Design联合研发一系列印花图案，并发布于趋势网站供会员客户参考使用。
                  <br />
                  <div
                    r="50"
                    g="83"
                    b="93"
                    className={`${styles.maskBlock} animate1`}
                    style={{ background: "rgb(50, 83, 93)" }}
                  />
                </span>
              </div>
            </div>

            <div
              className={styles["page2-timeline-pic"]}
              style={{
                width: getRem(76),
                height: getRem(42),
                top: getRem(155),
                left: 0,
              }}
            >
              <img src={img_2020_2} />
            </div>
          </div>

          <div className={styles["page2-timeline-year"]}>2021</div>
          <div className={styles["page2-timeline-line"]}>
            <div
              className={styles["page2-timeline-desc"]}
              style={{ bottom: getRem(22) }}
            >
              <div className={styles["page2-timeline-desc-title"]}>升级</div>

              <div className={styles["page2-timeline-desc-text"]}>
                <span className="animate1-wrapper">
                  2021年8月，专注新品牌、新人才、新运营等内容的教育平台——WOW-STAR星创力诞生
                  <br />
                  <div
                    r="50"
                    g="83"
                    b="93"
                    className={`${styles.maskBlock} animate1`}
                    style={{ background: "rgb(50, 83, 93)" }}
                  />
                </span>

                <div
                  style={{
                    width: getRem(87),
                    height: getRem(87),
                    marginTop: getRem(12),
                  }}
                >
                  <img alt="" src={img_2021_1} />
                </div>
                <br />
              </div>
            </div>

            <div
              className={styles["page2-timeline-desc"]}
              style={{ bottom: getRem(-132) }}
            >
              <div className={styles["page2-timeline-desc-text"]}>
                <span className="animate1-wrapper">
                  2021年12月，随着企业的高速发展，我们在2020年10月全面升级了WOW-TREND品牌Ⅵ系统，全新的品牌定位与视觉形象，更精准地传递了品牌核心价值。并在2021年12月我们的品牌升级项目被收入进了华人设计中有着至高荣誉的权威年鉴《BRAND创意呈现Ⅷ》中。
                  <br />
                  <div
                    r="50"
                    g="83"
                    b="93"
                    className={`${styles.maskBlock} animate1`}
                    style={{ background: "rgb(50, 83, 93)" }}
                  />
                </span>
              </div>
            </div>

            <div
              className={styles["page2-timeline-pic"]}
              style={{
                width: getRem(158),
                height: getRem(205),
                top: getRem(155),
                left: 0,
              }}
            >
              <img src={img_2021_2} />
            </div>
          </div>

          <div className={styles["page2-timeline-year"]}>2023</div>
          <div className={styles["page2-timeline-line"]}>
            <div
              className={styles["page2-timeline-desc"]}
              style={{ bottom: getRem(22) }}
            >
              <div className={styles["page2-timeline-desc-text"]}>
                <span className="animate1-wrapper">
                  2023年5月，服装人“找款选图”福音——热点趋势APP 上线
                  <br />
                  <div
                    r="50"
                    g="83"
                    b="93"
                    className={`${styles.maskBlock} animate1`}
                    style={{ background: "rgb(50, 83, 93)" }}
                  />
                </span>

                <div
                  style={{
                    width: getRem(87),
                    height: getRem(87),
                    marginTop: getRem(12),
                  }}
                >
                  <img src={img_2023} />
                </div>
                <br />
              </div>
            </div>
          </div>

          <div className={styles["page2-timeline-year"]}>FUTURE</div>
          <div className={styles["page2-timeline-line"]}>
            <div
              className={styles["page2-timeline-desc"]}
              style={{
                top: getRem(39),
              }}
            >
              <div className={styles["page2-timeline-desc-title"]}>展望</div>

              <div className={styles["page2-timeline-desc-text"]}>
                未来，WOW-TREND热点趋势将继续站在战略高度为时尚企业提供更多元的整合服务，为促进整个行业发展贡献力量。
                <div
                  r="50"
                  g="83"
                  b="93"
                  className={`${styles.maskBlock} animate1`}
                  style={{ background: "rgb(50, 83, 93)" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page2;
